/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_FailedInputs */

const vi_auth_login_failed = /** @type {(inputs: Auth_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập thất bại`)
};

/**

* @param {Auth_Login_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const auth_login_failed = /** @type {((inputs?: Auth_Login_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_auth_login_failed(inputs)
});